import type { HttpResponse } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { ownedError } from 'core/utils/owned-error';
import { of, pipe, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export function checkExistenceByHeadRequest(existCode: number = 200, notExistCode: number = 404) {
  return pipe(
    map<HttpResponse<void>, boolean>((r) => {
      if (r.status === existCode) {
        return true;
      }

      throw ownedError(new Error(`Unexpected response code. Expected: ${existCode}. Given: ${r.status}`));
    }),
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse && err.status === notExistCode) {
        return of(false);
      }

      return throwError(err);
    }),
  );
}
